import {
  APP_INIT,
  APP_INIT_SUCCESS,
  APP_INIT_FAILED,
} from '../types/appInit';

export const appInit = () => ({ type: APP_INIT } as const);
export const appInitSuccess = () => ({ type: APP_INIT_SUCCESS } as const);
export const appInitFailed = () => ({ type: APP_INIT_FAILED } as const);
